import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AppLayout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import Performance from "@/pages/Performance";
import Timesheet from "@/pages/Timesheet";
import Projects from "@/pages/Projects";
import Templates from "@/pages/Templates";
import Clients from "@/pages/Clients";
import ProductManagers from "@/pages/ProductManagers";
import Users from "@/pages/Users";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";
import { Toaster } from "sonner";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      <div className="animate-pulse">Loading…</div>
    </div>
  );
}

function Protected({ children, leaderOnly = false }) {
  const { user, loading, isLeaderView } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (leaderOnly && !isLeaderView) return <Navigate to="/" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/" element={<Protected><AppLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="performance" element={<Performance />} />
            <Route path="timesheet" element={<Timesheet />} />
            <Route path="projects" element={<Projects />} />
            <Route path="templates" element={<Templates />} />
            <Route path="clients" element={<Clients />} />
            <Route path="product-managers" element={<ProductManagers />} />
            <Route path="users" element={<Protected leaderOnly><Users /></Protected>} />
            <Route path="audit" element={<Protected leaderOnly><AuditLogs /></Protected>} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
